/**
 * ЗВУК ЗВОНКА
 *
 * Считается на месте, а не берётся файлом. Причина не в экономии:
 * файл со звуком пришлось бы откуда-то скачивать, а в этом проекте
 * ни один запрос не уходит за пределы страны — значит, файл лежал бы
 * в самом приложении и весил бы больше, чем весь остальной звук вместе
 * взятый.
 *
 * Два тона, 440 и 480 герц, по секунде звона и четыре паузы — это
 * привычный городской гудок. Узнаётся мгновенно и не пугает.
 */

type Ring = { stop: () => void }

/**
 * Звук можно включить только после того, как человек чего-нибудь
 * нажал: браузер молча запрещает звук на странице, куда ещё не
 * прикасались. Поэтому неудачу тут проглатываем — беззвучный звонок
 * лучше, чем упавшая страница.
 */
export function startRinging({ outgoing = false } = {}): Ring {
  let context: AudioContext | null = null
  let timer: ReturnType<typeof setInterval> | null = null
  let stopped = false

  try {
    context = new AudioContext()
  } catch {
    return { stop: () => {} }
  }

  const beep = () => {
    if (!context || stopped) return

    const gain = context.createGain()
    gain.connect(context.destination)

    // Плавное появление и затухание: резкий щелчок в начале тона
    // слышен как треск
    const now = context.currentTime
    const length = outgoing ? 1 : 1.2

    gain.gain.setValueAtTime(0, now)
    gain.gain.linearRampToValueAtTime(0.14, now + 0.05)
    gain.gain.setValueAtTime(0.14, now + length - 0.08)
    gain.gain.linearRampToValueAtTime(0, now + length)

    for (const frequency of [440, 480]) {
      const tone = context.createOscillator()
      tone.frequency.value = frequency
      tone.type = 'sine'
      tone.connect(gain)
      tone.start(now)
      tone.stop(now + length)
    }
  }

  beep()
  // Исходящему звонку — длиннее пауза: так он не торопит
  timer = setInterval(beep, outgoing ? 4000 : 3000)

  return {
    stop: () => {
      stopped = true
      if (timer) clearInterval(timer)
      void context?.close().catch(() => {})
      context = null
    },
  }
}
